<template functional>
  <div :class="[$style.form, windowsWidth <=700 && $style.mobileFormCard]">
    <slot />
  </div>
</template>

<style lang="scss" module>
.form {
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;

  &.mobileFormCard {
    max-width: 428px;
  }
}
</style>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      windowsWidth: state => state.ui.windowsWidth,
    }),
  },
};

</script>
